import { I18n } from '@calendly/i18n'
import { BrandLogo } from '@calendly/ui/components/brand-logo'
import { Body, Header, Popup } from '@calendly/ui/components/popup'
import { ProTip } from '@calendly/ui/components/pro-tip'
import { BodyText } from '@calendly/ui/components/typography'
import { useHistory } from 'react-router-dom'


import { LogoWrapper, NewAccountConnectionsContainer, ProviderGroupTitleWrapper } from './styles'
import { OutlookTooltip } from './tooltips'
import { CALENDAR_SETTINGS_PATH } from '../../constants'
import { Container as ProvidersContainer } from '../../integration_card'
import { ConnectCalendarAccount } from '../connect_account'

const GoogleProviderGroupTitle = () => (
  <ProviderGroupTitleWrapper>
    <LogoWrapper><BrandLogo name="google-calendar" /></LogoWrapper>
    <BodyText weight="bold">
      {I18n.t('publisher.availability_settings.section.calendar_settings.account_connection_popup.new_connection.provider.google')}
    </BodyText>
  </ProviderGroupTitleWrapper>
)

const MicrosoftProviderGroupTitle = () => (
  <ProviderGroupTitleWrapper>
    <LogoWrapper><BrandLogo name="microsoft" /></LogoWrapper>
    <BodyText weight="bold">
      {I18n.t('publisher.availability_settings.section.calendar_settings.account_connection_popup.new_connection.provider.microsoft')}
    </BodyText>
    <ProTip><OutlookTooltip /></ProTip>
  </ProviderGroupTitleWrapper>
)

export const NewConnectionPopup = () => {
  const history = useHistory()
  const onClose = () => history.push(CALENDAR_SETTINGS_PATH)

  return (
    <Popup onClose={onClose} size="medium" withCloseButton>
      <Header
        title={I18n.t('publisher.availability_settings.section.calendar_settings.account_connection_popup.new_connection.title')}
        eyebrowLabel={I18n.t('publisher.availability_settings.section.calendar_settings.account_connection_popup.new_connection.eyebrow')}
        subtitle={I18n.t('publisher.availability_settings.section.calendar_settings.account_connection_popup.new_connection.description')}
      />
      <Body>
        <NewAccountConnectionsContainer>
          <GoogleProviderGroupTitle />
          <ProvidersContainer>
            <ConnectCalendarAccount provider="google" minimalistic />
          </ProvidersContainer>
          <MicrosoftProviderGroupTitle />
          <ProvidersContainer>
            <ConnectCalendarAccount provider="outlook" minimalistic />
            <ConnectCalendarAccount provider="exchange" minimalistic />
          </ProvidersContainer>
        </NewAccountConnectionsContainer>
      </Body>
    </Popup>
  )
}
